import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const CookieBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(() => {
    return localStorage.getItem('cookieConsent') !== 'true';
  });

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
  };
  const rejectAll = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-0 left-0 w-full bg-gray-900 text-white px-4 py-4 z-50 flex flex-col md:flex-row items-center justify-between shadow-lg">
      <span className="mb-2 md:mb-0">{t('cookie_banner_text')} <a href="/cookie-policy" className="underline text-gold">{t('cookie_policy_link')}</a></span>
      <div className="flex gap-2">
        <button onClick={acceptAll} className="bg-gold text-black font-bold px-4 py-2 rounded-lg hover:bg-yellow-400 transition">{t('cookie_accept_all')}</button>
        <button onClick={rejectAll} className="bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition">{t('cookie_reject_all')}</button>
      </div>
    </div>
  );
};

export default CookieBanner;
